import React, { Component } from "react";
import { Title } from "../Styles";
import { HoverButton } from "./Styles/Platform.style";
import { TextBox } from "../Shared/FormHelpers";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Button = styled.i`
  color: #0071bc;
`;

export default class WorkExperienceForm extends Component {
  state = {
    experiences: [
      {
        title: "",
        company: "",
        start_date: new Date(),
        end_date: new Date(),
        profile_id: this.props.profile.id,
      },
    ],
    updatedExperiences: new Set(),
    loaded: false,
  };

  componentWillReceiveProps(props) {
    const { profile } = props;
    profile &&
      profile.work_experiences &&
      !this.state.loaded &&
      this.setState({
        experiences: [...profile.work_experiences, ...this.state.experiences],
        loaded: true,
      });
  }

  addWorkExperience = () => {
    const updatedExperiences = Array.from(this.state.updatedExperiences);
    const exp = this.state.experiences
      .filter((_, i) => updatedExperiences.includes(i))
      .map((exp) => {
        return {
          title: exp.title,
          company: exp.company,
          start_date: exp.start_date,
          end_date: exp.end_date,
          profile_id: exp.profile_id,
          id: exp.id ? exp.id : undefined,
        };
      });
    updatedExperiences.length && this.props.add(exp);
    updatedExperiences.includes(this.state.experiences.length - 1) &&
      this.setState({
        ...this.state,
        experiences: this.state.experiences.concat({
          title: "",
          company: "",
          start_date: new Date(),
          end_date: new Date(),
          profile_id: this.props.profile.id,
        }),
      });

    this.setState({ updatedExperiences: new Set() });
  };

  deleteWorkExperience = (id) => {
    const exp = this.state.experiences.filter((_, i) => i !== id);
    const deleteExp = this.state.experiences.find((_, i) => i === id);
    if (deleteExp.id) this.props.delete(deleteExp.id);
    this.setState({
      experiences: exp,
    });
  };

  handleChange = (event, index, optional) => {
    let { name, value } = event.target ? event.target : event;
    if (name === "current") value = value === "on";
    let current = this.state.experiences;

    if (!event.target) current[index][optional] = event;

    current[index] = { ...this.state.experiences[index], ...{ [name]: value } };
    this.setState({
      experiences: current,
      updatedExperiences: this.state.updatedExperiences.add(index),
    });
  };

  render() {
    const CustomDateInput = ({ value, onClick }) => (
      <DateInput onClick={onClick} value={value} />
    );

    const DateInput = styled.input`
      width: 100%;
      padding: 6px 22px;
      height: 48px;
      margin-bottom: 10px;
    `;
    return (
      <React.Fragment>
        <Title>Work Experience</Title>
        <div className="profile_detail post">
          {this.state.experiences.length &&
            this.state.experiences.map((exp, i) => (
              <Row key={i}>
                <Col lg={3}>
                  <TextBox
                    type="text"
                    placeholder="Job Title"
                    className="form-control form-control-lg"
                    name="title"
                    id="title"
                    value={exp.title}
                    onChange={(e) => this.handleChange(e, i)}
                  />
                </Col>
                <Col lg={3}>
                  <TextBox
                    type="text"
                    placeholder="Company"
                    name="company"
                    id="company"
                    className="form-control form-control-lg"
                    value={exp.company}
                    onChange={(e) => this.handleChange(e, i)}
                  />
                </Col>
                <Col lg={2}>
                  <DatePicker
                    selected={Date.parse(exp.start_date)}
                    placeholderText="Start date"
                    onChange={(e) => this.handleChange(e, i, "start_date")}
                    name="startDate"
                    id="startDate"
                    dateFormat="MM/yyyy"
                    maxDate={new Date()}
                    customInput={<CustomDateInput />}
                  />
                </Col>
                <Col lg={2}>
                  <DatePicker
                    selected={Date.parse(exp.end_date)}
                    placeholderText="End date"
                    onChange={(e) => this.handleChange(e, i, "end_date")}
                    name="endDate"
                    id="endDate"
                    maxDate={new Date()}
                    dateFormat="MM/yyyy"
                    customInput={<CustomDateInput />}
                  />
                </Col>
                <Col lg={1}>
                  <div
                    className="searchable form-check"
                    style={{ paddingTop: "1.5rem" }}
                  >
                    <label
                      htmlFor={`checkbox7${i}`}
                      className="form-check-label"
                    >
                      <input
                        type="checkbox"
                        id={`checkbox7${i}`}
                        name="current"
                        className="form-check-input"
                        onChange={(e) => this.handleChange(e, i)}
                      />
                      Current
                    </label>
                  </div>
                </Col>
                {i !== this.state.experiences.length - 1 && (
                  <Col lg={1}>
                    <Button
                      style={{ cursor: "pointer", paddingTop: "1.5rem" }}
                      className="fa fa-trash"
                      onClick={() => this.deleteWorkExperience(i)}
                    ></Button>
                  </Col>
                )}
              </Row>
            ))}
          <HoverButton
            type="button"
            className="btn btn-primary btn_apply white_bg"
            hoverData="Create profile first before adding your work experiences"
            hover={!this.props.profile.id}
            onClick={this.addWorkExperience}
            disabled={!this.props.profile.id}
          >
            Add
          </HoverButton>
        </div>
      </React.Fragment>
    );
  }
}
